import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Clock = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="clock__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#clock__a)">
          <path
            d="M8,1.5C6.7143993,1.5,5.4576995,1.88121998,4.3887947,2.5954499C3.3198748,3.309675,2.48675466,4.324840099999999,1.99478471,5.5125499C1.5028147697,6.7003002,1.37409472,8.0072002,1.62489974,9.2680998C1.87570477,10.5289497,2.4947648,11.68715,3.4038098000000003,12.5962C4.3128498,13.50525,5.4710494999999995,14.1243,6.7319002,14.3751C7.9927998,14.6259,9.2997503,14.4972,10.4874496,14.0052C11.67515,13.51325,12.69035,12.68015,13.40455,11.6112C14.1188,10.5423002,14.5,9.285599699999999,14.5,8C14.4982,6.27665,13.8128,4.6244102,12.5942,3.4058149C11.3755999,2.1872251,9.7233496,1.5018199682,8,1.5ZM11.5,8.5L8,8.5C7.8674002,8.5,7.7402,8.4473,7.64645,8.35355C7.5527,8.2598,7.5,8.132599800000001,7.5,8L7.5,4.5C7.5,4.3673902,7.5527,4.2402148,7.64645,4.146444799999999C7.7402,4.0526800000000005,7.8674002,4,8,4C8.132599800000001,4,8.2598,4.0526800000000005,8.35355,4.146444799999999C8.4473,4.2402148,8.5,4.3673902,8.5,4.5L8.5,7.5L11.5,7.5C11.6326,7.5,11.7598,7.5527,11.85355,7.64645C11.9473,7.7402,12,7.8674002,12,8C12,8.132599800000001,11.9473,8.2598,11.85355,8.35355C11.7598,8.4473,11.6326,8.5,11.5,8.5Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
